import React, { useContext, useMemo } from 'react';
import { ObjektLank } from '../../../../../_Common/Components/BusinessCollectionComponents/ObjektLank/ObjektLank';
import { AktivitetQuery_node_TEDBOAktivitet__Associations as IAktivitetAssociations } from '../../Queries/_QueryTypes/AktivitetQuery';
import { useQuery } from '@apollo/client';
import {
  GiltigVerksamhetsTypQuery,
  GiltigVerksamhetsTypQueryVariables,
} from '../../Queries/_QueryTypes/GiltigVerksamhetsTypQuery';
import { ISuggestion } from '../../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import NodeGiltigVerksamhetsTyp from '../../Queries/GiltigVerksamhetsTypQuery.gql';
import { ActiveDatabaseContext } from '../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { BusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';

interface IProps {
  sysOptionKravVerksamhetstyp: boolean;
}

export const VerksamhetstypSelect: React.FC<IProps> = (props: IProps) => {
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const formContext = useContext(BusinessDataFormContext);
  const bokningsgruppID =
    formContext?.formState?.currentValues?._Associations?.Bokningsgrupp?.id ??
    '';
  const verksamhetstypID =
    formContext?.formState?.currentValues?._Associations?.Verksamhetstyp?.id ??
    '';

  const { data: GiltigVerksamhetsTyp } = useQuery<
    GiltigVerksamhetsTypQuery,
    GiltigVerksamhetsTypQueryVariables
  >(NodeGiltigVerksamhetsTyp, {
    variables: {
      dbname: activeDatabase ?? '',
      BokningsgruppID: bokningsgruppID,
      VerksamhetstypID: verksamhetstypID,
    },
    fetchPolicy: 'network-only',
    skip: !bokningsgruppID || bokningsgruppID === '',
  });

  const validValues = useMemo(() => {
    return (
      GiltigVerksamhetsTyp?.rtn?.BOGiltigVerksamhetsTypQuery?.map(
        resitem =>
          ({
            name: resitem.KOD + ' - ' + resitem.BENAMNING,
            value: String(resitem.ID), // ← coerce to string
            data: {
              AnvandsPaGrupp: resitem.AnvandsPaGrupp,
              BENAMNING: resitem.BENAMNING,
              KOD: resitem.KOD,
            },
          } as ISuggestion<string>)
      ) ?? []
    );
  }, [GiltigVerksamhetsTyp?.rtn?.BOGiltigVerksamhetsTypQuery]);

  return (
    <ObjektLank<IAktivitetAssociations>
      associationName="Verksamhetstyp"
      testId="Verksamhetstyp"
      required={props.sysOptionKravVerksamhetstyp}
      validValues={{
        dataDependencies: ['AnvandsPaGrupp'], //Forts bokningsgrupp
        // getValidValues returnerar verksamhetstyper_all om det inte finns en ValidValuesfunction
        // If we want to skip steps fix in useAssociationValues.ts
        validValuesFunction: options =>
          options.filter(option =>
            validValues.some(v => v.value === option.value)
          ),
      }}
      onAssociationSelected={suggestion => {
        formContext?.update([
          {
            operation: 'Ref',
            associationName: 'Verksamhetstyp',
            id: suggestion ? suggestion.value : null,
            values: suggestion
              ? {
                  AnvandsPaGrupp: suggestion.data.AnvandsPaGrupp,
                  // ↓↓ to send the name of the verksamhetstyp so it can be used as a title
                  BENAMNING: suggestion.data.BENAMNING,
                }
              : null,
          },
        ]);
      }}
      value={
        formContext?.formState.currentValues?._Associations?.Verksamhetstyp?.id
      }
    />
  );
};
